export default (function (newFn, rest) {
  return function () {
    var newResult = newFn.apply(void 0, arguments);

    if (newResult !== undefined && newResult !== null) {
      return newResult;
    }

    return rest.apply(void 0, arguments);
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-convert/esm/util/accumulateFunction.js
// module id = 816
// module chunks = 0